import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Tooltip } from '@material-ui/core';
import { StyleRules, createStyles, withStyles } from '@material-ui/core/styles';

interface HomeButtonProps {
    tooltipTitle: string;
    homeRoute: string;
    children: any;
    classes?: any;
}

const styles = (): StyleRules => {
    return createStyles({
        button: {
            padding: 0,
            justifyContent: 'start',
            minWidth: 0
        }
    });
};

const HomeButton: React.FunctionComponent<HomeButtonProps> = (props: HomeButtonProps): JSX.Element => {
    return (
        <Tooltip title={props.tooltipTitle}>
            <Button
                component={Link}
                to={props.homeRoute}
                aria-label='Back to Home'
                classes={{ root: props.classes.button }}
            >
                {props.children}
            </Button>
        </Tooltip>
    );
};

export default withStyles(styles)(HomeButton);
